<div class="update-toast-container">
  <div class="toast-icon">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="23 4 23 10 17 10"></polyline>
      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
    </svg>
  </div>
  <div class="toast-content">
    <div class="toast-title">{{ 'app.update.available.title' | translate }}</div>
    <div class="toast-message">{{ 'app.update.available.message' | translate }}</div>
    <button class="reload-button" (click)="reloadApp()" type="button">
      {{ 'app.update.reload.button' | translate }}
    </button>
  </div>
  <button class="close-button" (click)="remove()" type="button" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
